export const sortCategories = [
    { name: 'All', id: 'all', arrow: false, asc: true },
    { name: 'Target Time', id: 'targetFromDate', arrow: false, asc: true },
    // { name: 'Target To Date', id: 'targetToDate', arrow: false, asc: true },
    { name: 'Achieved Target', id: 'achievedTarget', arrow: false, asc: true },
    { name: 'Target', id: 'target', arrow: false, asc: true }
]